import { connectivityService } from '~/data/connectivity/ConnectivityService';
import { issueLocal } from '~/data/local';
import { issueRemote } from '~/data/remote';
import {
  IssueDetails,
  IssuePayload,
  IssueResponsePayload,
} from '~/types';
import store from '~/store';

export class IssueRepository {
  async getIssue(id: IssueDetails['id']): Promise<IssueDetails | undefined> {
    if (connectivityService.isOnline()) {
      const data = await issueRemote.fetchIssue(id);
      if (store.getState().machines.isOfflineAvailable(data.machineId)) {
        await issueLocal.updateIssueDetail(data);
      }
      return data;
    }
    return issueLocal.getIssue(id);
  }

  async fetchAndCacheFavoriteIssues(scope: IssueDetails['id']): Promise<IssueDetails[]> {
    if (!connectivityService.isOnline()) {
      return [];
    }
    const data = await issueRemote.fetchFavoriteIssues(scope);
    await issueLocal.reset(data);
    return data;
  }

  async saveIssue(payload: IssuePayload): Promise<IssueResponsePayload> {
    if (connectivityService.isOnline()) {
      return issueRemote.saveIssue(payload);
    }
    return (await issueLocal.saveIssue(payload)) as IssueResponsePayload;
  }
}

export const issueRepository = new IssueRepository();
